<div [class]="getClassName()">
  <ol
    [class]="getStepListClassName(currentStatus()?.pipeline?.showAsFullscreen)"
  >
    @for (
      step of pipelineSteps();
      track step.label;
      let isFirst = $first;
      let isLast = $last
    ) {
      <li
        [class]="getStepWrapperClassName(isFirst, isLast)"
        [imTooltip]="
          (step.isActive || narrowScreen) &&
          !currentStatus()?.pipeline?.showAsFullscreen
            ? (step.tooltip | translate)
            : null
        "
        [openDelay]="tooltipOpenDelay"
        position="bottom"
      >
        <div
          [class]="
            getStepItemClassName(isFirst, isLast, step.isActive, step.hasPassed)
          "
        >
          <div [class]="'icon icon--' + step.iconType"></div>
          <span [class]="baseClass + '__step-label'">{{
            step.label | translate
          }}</span>
        </div>
      </li>
    }
  </ol>
  @if (currentStatus()?.pipeline?.showAsFullscreen) {
    <div
      [class]="
        getFullscreenStatusClassName(
          currentStatus().hide,
          currentStatus().isTenant
        )
      "
      [imTooltip]="currentStatus()?.pipeline?.tooltip | translate"
      [openDelay]="tooltipOpenDelay"
      position="bottom"
    >
      @switch (propertyType()) {
        @case ('GARAGE') {
          {{ currentStatus()?.pipeline?.garageLabel | translate }}
        }
        @case ('COMMERCIAL') {
          {{ currentStatus()?.pipeline?.commercialLabel | translate }}
        }
        @default {
          {{ currentStatus()?.pipeline?.label | translate }}
        }
      }
    </div>
  }
</div>
